<template>

</template>

<script>
export default {
  name: "CommentPage"
}
</script>

<style scoped>

</style>